import { clamp } from '../../render/utils/math';

export const gamma = {
  name: 'gamma',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;

// Gamma 值 (例如 1.0, 2.2, 0.45)
uniform float u_gamma;

void main() {
    vec4 color = texture2D(u_image, v_texCoord);
    vec3 exponent = vec3(1.0 / u_gamma);
    vec3 corrected_color = pow(color.rgb, exponent);
    gl_FragColor = vec4(corrected_color, color.a);
}`,
  uniforms: [
    {
      name: 'u_gamma',
      normalize: (value: number) => clamp((value / 100) * 2 + 1, 1, 3),
    },
  ],
};
